import React, { Component } from 'react';
import { View } from 'react-native';

import SearchBar from './searchBar';

import styles from './styles';

export default class AppHeader extends Component {
    render() {
        return (
            <View style={styles.content}>
                <SearchBar searchChange={this.props.onSearchChange} />
            </View>
        );
    }
}
